import { Box, Stack, Avatar, Typography, Divider } from '@mui/material';
import { Schema } from '../../../../../amplify/data/resource';
import { Icon } from '@iconify/react';
import CoinsIcon from '../../../icons/CoinsIcon';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

const Main = () => {
  return (
    <Stack spacing={5} sx={{ width: '100%', alignItems: 'center' }}>
      <UserAvatar fullName={'PielaPay Admin'} />
      <Stack
        sx={{ width: '100%' }}
        spacing={3}
        divider={<Divider orientation="horizontal" />}
      ></Stack>
      <Buttons />
    </Stack>
  );
};

export default Main;

const UserAvatar = ({ fullName }: { fullName: string }) => {
  return (
    <Stack spacing={2} sx={{ alignItems: 'center' }}>
      <Box>
        <Avatar
          sx={{
            borderRadius: '40px',
            width: '120px',
            height: '120px',
            bgcolor: '#DBE4EC',
            color: '#343434',
            fontWeight: '900',
            fontSize: '32px',
            fontFamily: 'Montserrat',
          }}
        >
          P
        </Avatar>
      </Box>
      <Typography
        fontWeight={'700'}
        fontSize={'30px'}
        fontFamily={'AlmoniDL'}
        color={'#424245'}
      >
        {fullName}
      </Typography>
    </Stack>
  );
};

const Buttons = () => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  return (
    <Stack spacing={2.3} sx={{ width: '100%' }}>
      <Stack
        sx={{
          boxSizing: 'border-box',
          width: '100%',
          background: '#F2F4F7',
          py: '13px',
          px: '28px',
          borderRadius: '17px',
          cursor: 'pointer',
        }}
        onClick={handleSignOut}
      >
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={1}
          alignItems="center"
        >
          <Typography
            fontWeight={'700'}
            fontSize={'20px'}
            fontFamily={'AlmoniDL'}
          >
            התנתק
          </Typography>
          <Icon width="22px" icon="si:sign-out-alt-fill" />
        </Stack>
      </Stack>
    </Stack>
  );
};
